export const isEmptyIgnoring = <T extends Record<string, any>>(object: T, ...ignoreFields: (keyof T)[]) =>
	object === undefined ||
	Object.entries(object).every(([key, value]) => ignoreFields.includes(key) || value === undefined)
